<div class="expanded-panel-header blue" (click)="toggleExpand()">Project Attributes</div>
@if(expanded){
  @for(row of rows; track $index){
    <div class="row" style="padding-left: 8px;padding-right: 8px;">
      @for(field of row; track field.key){
        <div class="col-md-4">
          <div class="row align-top" style="border-bottom: 1px solid lightgray">
            <div class="col-md-6 label">{{ field.label }}</div>
            @switch(field.key){
              @case('Prospect Probability'){
                @if(attributeDetail[field.key]){
                  <div class="col-md-6">{{ attributeDetail[field.key] | percent: '1.2-2'}}</div>
                }
                @if(!attributeDetail[field.key]){
                  <div class="col-md-6">--</div>
                }
              }
              @default {
                <div class="col-md-6">{{ attributeDetail[field.key] ?? '--' }}</div>
              }
            }
          </div>
        </div>
      }
    </div>
  }
}
